import router from '@/router'
import { IEDate, dispatchEventBus, openPopup, uGetDateFormat } from '@appbase/util';
import { EnumCalendarViewType } from './types';
import * as eventTypes from '@reserve/store/event-types'
import reserveStore from '@reserve/store'
import rootStore from '@/store'

export const openReserveResourceTime = function(comCode: string, startTime: Date, endTime: Date, itemStore: 'FAVORITE' | 'EWS' | 'DB', resource?: string) { 
    var param: reserve.ReserveResourceParam = {
        comCode: comCode,
        eventStart: uGetDateFormat('yyyy-MM-dd', IEDate(startTime)),
        eventEnd: uGetDateFormat('yyyy-MM-dd', IEDate(endTime)),
        eventStartTime: uGetDateFormat("H:i:00", IEDate(startTime)),
        eventEndTime: uGetDateFormat("H:i:00", IEDate(endTime)),
        itemStore: itemStore
    }

    if(resource) {
        param.resource = resource;
    }

    openReserveWindow({
        param: param
    })   
}

export const openReserveResourceDate = function(comCode: string, reserveDate: Date, itemStore: 'FAVORITE' | 'EWS' | 'DB', resource?: string) {
    var timeNow = IEDate(reserveDate);

    let calcStarttime: string = "";
    let calcEndtime: string = "";

    if(timeNow.getMinutes() < 30) {
        calcStarttime = uGetDateFormat("H:00:00", timeNow);
        calcEndtime = uGetDateFormat("H:30:00", timeNow);     
    } else {       
        calcStarttime = uGetDateFormat("H:30:00", timeNow);

        timeNow.setHours(timeNow.getHours() + 1);
        calcEndtime = uGetDateFormat("H:00:00", timeNow);
    }             

    var param: reserve.ReserveResourceParam = {
        comCode: comCode,
        eventStart: uGetDateFormat('yyyy-MM-dd', IEDate(reserveDate)),
        eventEnd: uGetDateFormat('yyyy-MM-dd', IEDate(reserveDate)),
        eventStartTime: calcStarttime,
        eventEndTime: calcEndtime,
        itemStore: itemStore
    }

    if(resource) {
        param.resource = resource;
    }

    openReserveWindow({
        param: param
    })    
}

export const openReserveCalendarItem = function(reserve: reserve.CalendarItem, masterOccurrence?: string) {               
    let openQuery: any = {
        itemStore: reserve.itemStore,
        resource: reserve.resourceUpn,        
    }

    if(masterOccurrence) {
        openQuery.open = masterOccurrence
    }

    if(reserve.itemStore === 'DB' && masterOccurrence) {
        openQuery.reserveId = reserve.db_masterID;
        openQuery.sequence = reserve.id;               

        let occurrenceParam = <reserve.ReserveResourceParam>{
            eventStart: uGetDateFormat('yyyy-MM-dd', IEDate(reserve.start)),
            eventEnd: uGetDateFormat('yyyy-MM-dd', IEDate(reserve.end)),
            eventStartTime: uGetDateFormat('H:i:s', IEDate(reserve.start)),
            eventEndTime: uGetDateFormat('H:i:s', IEDate(reserve.end))
        }

        openQuery.param = encodeURIComponent(btoa(JSON.stringify(occurrenceParam)));
    } else {
        openQuery.reserveId = reserve.id;
    }       

    router.push({
        name: 'reserve-write',
        query: openQuery
    });         
}

export const openReserveWindow = function(option: reserve.ReserveWindowOption) {
    let isTeams = rootStore.state.$appbase?.teams || false;
    let openParam: { [key: string]: string } = { };

    if(option.comCode) {
        openParam['comCode'] = option.comCode;
    }

    if(option.category) {
        openParam['itemStore'] = option.category;
    }

    if(option.resource) {
        openParam['resource'] = option.resource;
    }

    if(option.param) {
        openParam['param'] = encodeURIComponent(btoa(JSON.stringify(option.param)));
    }

    if(option.reserveId) {
        openParam['reserveId'] = option.reserveId;
    }   
    
    if(isTeams) {
        router.push({
            name: 'reserve-write',
            query: openParam
        })
    } else {
        var writeUrl = '/reservePopup/write';
        openPopup('eum-reserve-write', writeUrl, openParam, {
            width: 1100,
            height: 1000               
        })
    }        
}

export const handleClose = function(isPopup?: boolean, refresh?: boolean) {
    if(isPopup) {
        if(window.opener && refresh) {
            dispatchEventBus(window.opener, eventTypes.EVENT_RESOURCE_EVENTLOAD, {});
        }
        
        window.close();
    } else {
        if(refresh) {
            dispatchEventBus(window, eventTypes.EVENT_RESOURCE_EVENTLOAD, {});
        }

        switch(reserveStore.state.calendarMode) {
            case EnumCalendarViewType.Month:
                router.push({ name: 'reserve-month' });
                break;
            case EnumCalendarViewType.Week:
                router.push({ name: 'reserve-week' });
                break;
            default:
                router.push({ name: 'reserve-day' });
                break;
        }
    }
}